import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.dev';
import { StatesList } from '../helpers/Interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartyApiService {
  getStatesApiUrl = `${environment.baseUrl}/StateSalesTax`;

  constructor(private http: HttpClient) {}

  GetStates(): Observable<StatesList[]> {
    return this.http.get<StatesList[]>(this.getStatesApiUrl);
  }
}
